<template>
  <div>
    <van-nav-bar
      title="年审纪录"
      left-arrow
      @click-left="onClickLeft"
    />
    <div>
      <div class="" v-if="jlList.length > 0">
        <div v-for="(item, index) in jlList" :key="index" class="jlcard">
          <div class="fsb">
            <div class="name">{{item.userName}}</div>
            <div class="card">{{item.operType === 1 ? '自审' : '工作人员审核'}}</div>
          </div>
          <div class="fsb">
            <div class="fs">
            <div class="title"> {{item.auditTime}}</div>
            </div>
            <div  v-if="item.status === 1" class="title suc">通过</div>
            <div  v-if="item.status === 2" class="title fail">{{item.message}}</div>
          </div>
        </div>
        <van-divider v-if="jlList.length > 1"></van-divider>
      </div>
      <div v-else class="fsac" style="height: 80vh">
        <div class="">
          <div style="width: 100%" class="fsac">
        <img width="100" src="../../assets/empty.png">
        </div>
        <div class="emptyT">当前没有年审纪录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Toast, Button, Divider, NavBar, Tag, Icon} from 'vant'
  export default {
    components: {
      [Button.name]: Button,
      [Divider.name]: Divider,
      [NavBar.name]: NavBar,
      [Tag.name]: Tag,
      [Icon.name]: Icon
    },
    computed: {
      route () {
        return this.$route
      }
    },
    watch: {
      $route (to, from ) {
        // 监听路由变化, 实现类似 小程序的 onShow 事件
        if (to.path === '/my') {
          // do anything you want
        }
      }
    },
    async mounted() {
      await this.sbj()
      this.HelpUserGetAudiDetailList()
    },
    methods: {
      async sbj () {
        let{userId, userType} = this.$route.query
        this.userId = userId
        this.userType = Number(userType)
        console.log(userId, userType)
        if (this.userType === 2 && !this.userId) {
          Toast('非法访问！')
          // this.$router.replace('/index')
        }
      },
      onClickLeft () {
        this.$router.go(-1)
      },
      async HelpUserGetAudiDetailList () {
        let params = {page: 1, rows: 99}
        console.log(222)
        if (this.userType === 2) {
          console.log(11111)
          params.userId = this.userId
        }
        console.log(params)
        let {success, info, data} = await this.$api.HelpUserGetAudiDetailList(params)
        if (success) {
          this.jlList = data.rows
        } else {
          Toast(info)
        }
      },
    },
    data() {
      return {
        jlList: [],
        userId: '',
        userType: ''
      }
    }
  }
</script>
<style>
  .jlcard {
    border-radius: 6px;
    /* height: 28px; */
    line-height: 28px;
    margin: 10px;
    padding: 15px;
    font-size: 16px;
    background: #fff;
  }
  .jlcard .name {
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    color: #333;
    text-shadow: 0px 0px 1px #333;
  }
  .jlcard .card {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    color: #555;
  }
  .jlcard .title {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    color: #777;
  }
  .jlcard  .suc {
    text-align: end;
    color: #3187FF !important;
  }
  .jlcard  .fail {
    color: #DC143C !important;
  }
  .emptyT {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #777
  }
</style>